import React from 'react';

import { useHttpStatus } from '~/commons/hooks';
import FormContact from '../forms/FormContact.jsx';

import meta from '../../config/meta';

const PageContact = () => {
  const [res, req] = useHttpStatus();

  meta.set({ title: '學校申請試用帳戶' });

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        {res.status === 'success' ? (
          <div className="col-md-6 text-center">
            <h4>
              感謝你的申請!
            </h4>
            <p className="mt-4">
              本院將安排工作人員與你聯絡
            </p>
            <a
              href="/"
              className="btn btn-primary"
            >
              返回主頁
            </a>
          </div>
        ) : (
          <div className="col-sm-10 col-md-8 col-lg-6 col-xl-5">
            <h2 className="mb-4">學校申請試用帳戶</h2>
            <p>
              如學校老師希望取得試用帳戶以進一步了解更多國家識見閱讀計劃的內容和平台運作模式，請填寫以下資料，本院將安排工作人員與老師聯絡。
            </p>
            <FormContact
              res={res}
              onSubmit={(values) => req({
                method: 'post',
                url: '/api/site/contacts',
                data: values,
              })}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PageContact;
